import team from './team';
import services from './services';
import products from './products';
import blogs from './blogs';
import cars from './cars';
import portfolio from './portfolio';



const navbar = [
    {
        id: 1,
        mainLink : {link: '/', title: 'home'},
        subLink: [],
    },
    {
        id: 2,
        mainLink : {link: '#', title: 'about'},
        subLink: [
            {id: 1, link: '/About-us', title: 'about us'},
            {id: 2, link: '/Team', title: 'team'},
            {id: 3, link: '/Team/TeamSingle', title: 'team single', state: team[0]},
            {id: 4, link: '/Testimonials', title: 'testimonials'},
            {id: 5, link: '/Faqs', title: 'faqs'},
        ],
    },
    {
        id: 3,
        mainLink : {link: '#', title: 'Car'},
        subLink: [
            {id: 1, link: '/Car-Categories', title: 'Cars Categories'},
            {id: 2, link: '/Car-Grid', title: 'Car Grid'},
            {id: 3, link: '/Car-List', title: 'Car List'},
            {id: 4, link: '/Cars/Car-Single', title: 'Car Single', state: cars[0]},
            {id: 5, link: '/Car-Booking', title: 'Car Booking'},
        ],
    },
    {
        id: 4,
        mainLink: { title: "Pages", link: "#" },
        subLink: [
            { id: 1, link: "/Gallery", title: "Gallery"  },
            { id: 2, link: "/Services", title: "Services" },
            { id: 3, link: "/Services/Service-Single", title: "Service Single",  state: services[0] },
            { id: 4, link: "/Portfolio", title: "Portfolio" },
            { id: 5, link: "/Portfolio/Portfolio-Single", title: "Portfolio Single",  state: portfolio[0] },
            { id: 6, link: "*", title: "Error 404" },
            { id: 7, link: "/Services-Terms", title: "Terms of Services" },
            { id: 8, link: "/Privacy-Policy", title: "Privacy Policy" },
            { id: 9, link: "/Partners", title: "Partners" },

        ],
    },
    {
        id: 5,
        mainLink : {link: '#', title: 'blog'},
        subLink: [
            {id: 1, link: '/Blog-grid', title: 'blog grid'},
            {id: 2, link: '/Blog-list', title: 'blog list'},
            {id: 3, link: '/Blogs/Blog-Single', title: 'blog single', state: blogs[0]},
        ],
    },
    {
        id: 6,
        mainLink : {link: '#', title: 'shop'},
        subLink: [
            {id: 1, link: '/Shop-grid', title: 'shop grid'},
            {id: 2, link: '/Shop-list', title: 'shop list'},
            {id: 3, link: '/Shop/Product-Single', title: 'product single', state: products[0]},
            {id: 4, link: '/Wishlist', title: 'wishlist'},
            {id: 5, link: '/Cart', title: 'cart'},
            {id: 6, link: '/Checkout', title: 'checkout'},
            {id: 7, link: '/OrderConfirmation', title: 'Order Confirmation'},
            {id: 8, link: '/Login', title: 'login'},
            {id: 9, link: '/Register', title: 'register'},
            {id: 10, link: '/Forgot-pwd', title: 'forgot Password'},
        ],
    },
    {
        id: 7,
        mainLink : {link: '/Contact-us', title: 'contact'},
        subLink: [],
    },
];

export default navbar;